import { ref, onBeforeUnmount } from "vue";
import Pusher from "pusher-js";
import useActivationViber from "@/components/activation/api/useActivationViber";
import useActivationWhatsapp from "@/components/activation/api/useActivationWhatsapp";
import { useStore } from "vuex";

// Pusher.logToConsole = true;

export default function usePusherActivation() {
    const store = useStore();

    const { getLinkActivationViber, payloadLinkActivationViber } =
        useActivationViber();
    const { getLinkActivationWhatsapp, payloadLinkActivationWhatsapp } =
        useActivationWhatsapp();

    const pusherStatus = ref("");
    let pusher;
    const pusherActivation = async (phoneNumber) => {
        try {
            console.debug("start pusher");
            pusher = new Pusher(process.env.MIX_PUSHER_API_KEY, {
                cluster: "eu",
            });

            let textDialog;

            if (phoneNumber === 0) pusher.disconnect();

            const channel = pusher.subscribe(phoneNumber);
            window.pusher = pusher;
            // Проверяет есть ли ссылка на код. Если есть переходим на активацию кода.
            channel.bind("activation", async (data) => {
                console.debug("listen pusher");
                data.hasOwnProperty("number") &&
                    store.commit("activation/SET_ANOTHER_NUMBER", data.number); // !CHECK NUMBER UPDATES
                switch (data.status) {
                    case "Check QR":
                        if (
                            window.document.location.pathname.includes(
                                "activation"
                            )
                        ) {
                            switch (store.state.activation.messenger) {
                                case "viber":
                                    getLinkActivationViber(phoneNumber);
                                    break;
                                case "whatsapp":
                                    getLinkActivationWhatsapp(phoneNumber);
                                    break;
                                default:
                                    throw new Error("Messenger not found");
                            }
                            pusherStatus.value = "scanCode";
                        }
                        break;
                    case "QR timeout":
                        pusherStatus.value = "timeOver";
                        break;
                    case "Number successfully activated":
                        pusherStatus.value = "successActivation";
                        break;
                    case "Invalid number activated":
                        textDialog = "invalidNumberError";
                        break;
                    case "Existing number activated":
                        textDialog = "existsNumberError";
                        break;
                    case "Already activated number":
                        textDialog = "alreadyActivatedError";
                        break;
                    default:
                        pusherStatus.value = data.status;
                        break;
                }
                if (textDialog) {
                    store.commit("activation/SET_NUMBER", phoneNumber);

                    const params = {
                        number: phoneNumber,
                        info: textDialog || null,
                    };

                    store.commit("openDialog", {
                        name: "InformationDialog",
                        params,
                    });
                    pusherStatus.value = "errorActivation";
                }
            });

            const pusherConnected = () => {
                if (pusher.connection.state === "connected") {
                    console.debug("connected pusher");
                    // если есть связь с pusher

                    switch (store.state.activation.messenger) {
                        case "viber":
                            getLinkActivationViber(phoneNumber);
                            payloadLinkActivationViber.value.data &&
                                store.commit(
                                    "activation/SET_QR_LINK",
                                    payloadLinkActivationViber.value.data.link
                                );
                            break;
                        case "whatsapp":
                            getLinkActivationWhatsapp(phoneNumber);
                            payloadLinkActivationWhatsapp.value.data &&
                                store.commit(
                                    "activation/SET_QR_LINK",
                                    payloadLinkActivationWhatsapp.value.data
                                        .link
                                );
                            break;
                        default:
                            throw new Error("Messenger not found");
                    }
                } else {
                    console.debug("error pusher");
                    store.commit("acitvation/SET_IS_PUSHER", false);
                    pusherStatus.value = "pusherError";
                }
            };

            setTimeout(pusherConnected, 1000);
            clearTimeout(pusherConnected);
        } catch (error) {
            pusherStatus.value = "pusherError";
            store.commit("acitvation/SET_IS_PUSHER", false);
        }
        onBeforeUnmount(() => {
            if (pusher) {
                console.debug("disconnecting pusher");
                pusher.disconnect();
            }
        });
    };
    onBeforeUnmount(() => {
        if (pusher) {
            console.log('disconnect pusher', pusher);
            pusher.disconnect();
        }
    });
    return {
        pusherActivation,
        pusherStatus,
    };
}
